import { Component } from '@angular/core';

declare const MW: any;
declare const THREE: any;
declare const setupScene: any;
declare const MAP: any;

@Component({
  selector: 'app1',
  templateUrl: './app1.component.html'
})
export class App1Component {
  data = {};

  ngOnInit() {
    var that = this;
    var scene = setupScene("canvas1");
    var loader = new THREE.FontLoader();
    loader.load('https://threejs.org/examples/fonts/helvetiker_regular.typeface.json', function (font) {

        var data = {};
        var text = new THREE.Mesh(
            new THREE.TextGeometry("", {
                font: font,
                size: 2,
                height: 0.5,
                curveSegments: 16
            }),
            new THREE.MeshStandardMaterial({})
        );

        new MW.TwoWayMap({
            end1: data,
            map1: MAP.TEXT.to3DModel(font),
            end2: text,
            map2: MAP.TEXT.toDataModel,
            data1: {
                text: 'Hello world',
                diffuseColor: '#dd3300',
                emissiveColor: '#ee9966',
            }
        });
        
        scene.add(text);
        that.data = data;
    });
  }
}